/**
 * Declares a route's browser-tab title.
 *
 * Use it as the `head` option of a file route:
 *
 * ```ts
 * export const Route = createFileRoute("/_authenticated/admin/vehicles/")({
 *   component: VehiclesPage,
 *   head: () => pageTitle("Vehicles"),
 * });
 * ```
 *
 * Takes an i18n **key**, not a translated string: translation happens at render
 * time in <DocumentTitle /> so the tab follows the app language even when the
 * locale bundle arrives after the route has already matched.
 *
 * Never pass entity data (a name, license plate, reference or id) — the title
 * is sent to Matomo with every page view. See
 * plans/page-document-titles/00-overview.md and .claude/rules/security.md.
 */
export function pageTitle(titleKey: string) {
	return { meta: [{ title: titleKey }] };
}
